import React, { Suspense } from "react";
import { Routes, Route } from "react-router-dom";

import ContentControlLayout from "../../layout/ContentUnitLayout";
import ProtectedRoute from "../../layout/ProtectedLayout/ProtectedRoute";
import { ContentRoute } from "../../routers/ContentRoutes";
import SpinnerLayout from "../../core/components/layout/SpinnerLayout";
import { RouteMode } from "../../constant/enum/RouteAccessLevel";

const ContentUnit = () => {

  const renderRoutes = () => {
    return ContentRoute.map((route, index) => (<Route key={route.path} path={route.path} element={route.component} />) ); 
  }

  return (
    <ProtectedRoute layoutMode={RouteMode.CONTENT_ROUTE}>
      <ContentControlLayout>
        <Suspense fallback={<SpinnerLayout/>}>
        <Routes>
         {renderRoutes()}
        </Routes>
        </Suspense>
      </ContentControlLayout>
    </ProtectedRoute>
  );
};

export default ContentUnit;

